import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../redux-toolkit/hooks";
import * as Yup from 'yup';
import { getAllcountryDetail, setcountry } from "../../redux-toolkit/slices/countrySlice";
import { Modal } from "react-bootstrap";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useBulkSaveEntityMasterMutation, useGetAllEntityMasterMutation, useGetDueDiligenceMutation, useGetEntityMasterByIdMutation, useSaveEntityMasterMutation, useUpdateEntityMasterMutation } from "../../redux-toolkit/services/entityMasterService";
import { useBulkSaveSponsorMasterMutation, useGetAllSponsorMasterMutation, useGetSponsorMasterByIdMutation, useSaveSponsorMasterMutation, useUpdateSponsorMasterMutation } from "../../redux-toolkit/services/sponsorMasterService";
import { useBulkSaveFamilyOfficeMasterMutation, useFindAllFamilyOfficeMasterMutation, useGetFamilyOfficeMasterByIdMutation, useSaveFamilyOfficeMasterMutation, useUpdateFamilyOfficeMasterMutation } from "../../redux-toolkit/services/familyOfficeMasterService";
import { allEntityMasterDetails, getDueDiligenceData, setAllEntityMaster, setDueDiligence } from "../../redux-toolkit/slices/entityMasterSlice";
import { useGetAllCountryMutation } from "../../redux-toolkit/services/countryService";
import { getSponsorTypesData, setSponsorTypes } from "../../redux-toolkit/slices/enumSlice";
import { useGetSponsorTypesMutation } from "../../redux-toolkit/services/enumService";
import { useBulkSaveEntityTypeMasterMutation, useFindAllEntityTypeMasterMutation, useGetAllEntityTypeMasterBySearchMutation, useGetAllEntityTypeMasterMutation, useGetEntityTypeMasterByIdMutation, useSaveEntityTypeMasterMutation, useUpdateEntityTypeMasterMutation } from "../../redux-toolkit/services/entityTypeMasterService";
import { useBulkSaveInvestmentMandateTypeMasterMutation, useGetInvestmentMandateTypeByIdMutation, useSaveInvestmentMandateTypeMutation, useUpdateInvestmentMandateTypeMutation } from "../../redux-toolkit/services/investmentMandateTypeService";
import { allEntityTypeMasterDetails, setAllEntityTypeMaster } from "../../redux-toolkit/slices/entityTypeMasterSlice";
import { CATEGORY } from "../constant/AppConstant";
import { getFindStateByCountryNameDetail, setStates } from "../../redux-toolkit/slices/statesSlice";
import { useGetStateMutation } from "../../redux-toolkit/services/stateService";
import { format, parseISO } from "date-fns";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
    isCategory?: boolean;
    setIsCategory?: any;
};

const validationSchema = Yup.object().shape({
    percentageCompleted: Yup.number()
        .min(0, 'Percentage must be at least 0')
        .max(100, 'Percentage cannot exceed 100'),
});

const MasterData = (props: Props) => {

    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    const setFieldValueRef: any = useRef(null);

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [selectData, setSelectData]: any = useState();
    const [location, setLocation]: any = useState({ latitude: '', longitude: '' });
    const [fileName, setFileName] = useState("");

    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");

    //save
    const [saveEntityMaster, saveEntityMasterResponse] = useSaveEntityMasterMutation();
    const [saveEntityTypeMaster, saveEntityTypeMasterResponse] = useSaveEntityTypeMasterMutation();
    const [saveInvestmentMandateType, saveInvestmentMandateTypeResponse] = useSaveInvestmentMandateTypeMutation();
    const [saveSponsorMaster, saveSponsorMasterResponse] = useSaveSponsorMasterMutation();
    const [saveFamilyOfficeMaster, saveFamilyOfficeMasterResponse] = useSaveFamilyOfficeMasterMutation();

    //bulkSave
    const [bulkSaveEntityMaster, bulkSaveEntityMasterResponse] = useBulkSaveEntityMasterMutation();
    const [bulkSaveEntityTypeMaster, bulkSaveEntityTypeMasterResponse] = useBulkSaveEntityTypeMasterMutation();
    const [bulkSaveInvestmentMandateType, bulkSaveInvestmentMandateTypeResponse] = useBulkSaveInvestmentMandateTypeMasterMutation();
    const [bulkSaveSponsorMaster, bulkSaveSponsorMasterResponse] = useBulkSaveSponsorMasterMutation();
    const [bulkSaveFamilyOfficeMaster, bulkSaveFamilyOfficeMasterResponse] = useBulkSaveFamilyOfficeMasterMutation();

    //update
    const [updateEntityMaster, updateEntityMasterResponse] = useUpdateEntityMasterMutation();
    const [updateEntityTypeMaster, updateEntityTypeMasterResponse] = useUpdateEntityTypeMasterMutation();
    const [updateInvestmentMandateType, updateInvestmentMandateTypeResponse] = useUpdateInvestmentMandateTypeMutation();
    const [updateSponsorMaster, updateSponsorMasterResponse] = useUpdateSponsorMasterMutation();
    const [updateFamilyOfficeMaster, updateFamilyOfficeMasterResponse] = useUpdateFamilyOfficeMasterMutation();

    //getById mutation
    const [getEntityMasterById, entityMasterByIdResponse] = useGetEntityMasterByIdMutation();
    const [getEntityTypeMasterById, entityTypeMasterByIdResponse] = useGetEntityTypeMasterByIdMutation();
    const [getInvestmentMandateTypeById, investmentMandateTypeByIdResponse] = useGetInvestmentMandateTypeByIdMutation();
    const [getSponsorMasterById, sponsorMasterByIdResponse] = useGetSponsorMasterByIdMutation();
    const [getFamilyOfficeMasterById, familyOfficeMasterByIdResponse] = useGetFamilyOfficeMasterByIdMutation();

    //getData
    const [getAllEntityMaster, getAllEntityMasterResponse] = useGetAllEntityMasterMutation();
    const [getAllSponsorMaster, allSponsorMasterResponse] = useGetAllSponsorMasterMutation();
    const [findAllFamilyOfficeMaster, findAllFamilyOfficeMasterResponse] = useFindAllFamilyOfficeMasterMutation();
    const [getCountry, getCountryResponse] = useGetAllCountryMutation();
    const [getAllEntityTypes, getAllEntityTypesResponse] = useFindAllEntityTypeMasterMutation();
    const [getSponsorTypes, getSponsoreTypesResponse] = useGetSponsorTypesMutation();
    const [getState, getStateResponse] = useGetStateMutation();

    const [getDueDiligence, dueDiligenceRes] = useGetDueDiligenceMutation();

    //Data

    const allEntityMaster: any = useAppSelector(allEntityMasterDetails);
    const allCountries: any = useAppSelector(getAllcountryDetail);
    const allStates: any = useAppSelector(getFindStateByCountryNameDetail);
    const allEntityTypes: any = useAppSelector(allEntityTypeMasterDetails);
    const allSponsorTypes = useAppSelector(getSponsorTypesData);
    const dueDeligenceData: any = useAppSelector(getDueDiligenceData);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.ENTITY_MASTER) {
                getCountry({ token: localUserObj?.token, });
                if (props.data?.countryId) {
                    getState({
                        token: localUserObj.token,
                        countryId: props.data?.countryId,
                    });
                }
                getAllEntityTypes({ token: localUserObj?.token, });
                getEntityMasterById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.SPONSOR_MASTER) {
                getSponsorTypes({ token: localUserObj?.token, });
                getSponsorMasterById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
                getFamilyOfficeMasterById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
                getInvestmentMandateTypeById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            }

        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.ENTITY_MASTER) {
                getCountry({ token: localUserObj?.token, });
                getAllEntityTypes({ token: localUserObj?.token, });
            } else if (props.reportName === REPORT_NAME.SPONSOR_MASTER) {
                getSponsorTypes({ token: localUserObj?.token, });
            } else if (props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
            } else if (props.reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
            }
        }
    }, [props.reportName]);

    useEffect(() => {
        if (getCountryResponse.isSuccess) {
            dispatch(setcountry(getCountryResponse));
        } else if (getCountryResponse.isError) {
            alertMessage("Error while fetching countries", "error");
        }
    }, [getCountryResponse.isSuccess, getCountryResponse.isError]);

    useEffect(() => {
        if (getStateResponse.isSuccess) {
            dispatch(setStates(getStateResponse));
        } else if (getStateResponse.isError) {
            alertMessage("Error while fetchin states", "error");
        }
    }, [getStateResponse.isSuccess, getStateResponse.isError]);

    useEffect(() => {
        if (getAllEntityTypesResponse.isSuccess) {
            dispatch(setAllEntityTypeMaster(getAllEntityTypesResponse));
            console.log(getAllEntityTypesResponse)
        } else if (getAllEntityTypesResponse.isError) {
            alertMessage("Error while fetching Entity Types", "error");
        }
    }, [getAllEntityTypesResponse.isSuccess, getAllEntityTypesResponse.isError]);

    useEffect(() => {
        if (getSponsoreTypesResponse.isSuccess) {
            dispatch(setSponsorTypes(getSponsoreTypesResponse));
        } else if (getSponsoreTypesResponse.isError) {
            alertMessage("Error while fetching Sponsor Types", "error");
        }
    }, [getSponsoreTypesResponse.isSuccess, getSponsoreTypesResponse.isError]);

    useEffect(() => {
        if (dueDiligenceRes.isSuccess) {
            dispatch(setDueDiligence(dueDiligenceRes));
        } else if (dueDiligenceRes.isError) {
            alertMessage("Error while fetching Data from LLM", "error");
        }
    }, [dueDiligenceRes.isSuccess, dueDiligenceRes.isError]);

    useEffect(() => {
        if (saveEntityMasterResponse.isSuccess) {
            const response: any = saveEntityMasterResponse.data;
            alertMessage("Entity Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveEntityMasterResponse.isError) {
            let response: any = saveEntityMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveEntityMasterResponse.isSuccess, saveEntityMasterResponse.isError]);

    useEffect(() => {
        if (saveEntityTypeMasterResponse.isSuccess) {
            const response: any = saveEntityTypeMasterResponse.data;
            alertMessage("Entity Type Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveEntityTypeMasterResponse.isError) {
            let response: any = saveEntityTypeMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveEntityTypeMasterResponse.isSuccess, saveEntityTypeMasterResponse.isError]);

    useEffect(() => {
        if (saveInvestmentMandateTypeResponse.isSuccess) {
            const response: any = saveInvestmentMandateTypeResponse.data;
            alertMessage("Investment Mandate Type added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveInvestmentMandateTypeResponse.isError) {
            let response: any = saveInvestmentMandateTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveInvestmentMandateTypeResponse.isSuccess, saveInvestmentMandateTypeResponse.isError]);

    useEffect(() => {
        if (saveSponsorMasterResponse.isSuccess) {
            const response: any = saveSponsorMasterResponse.data;
            alertMessage("Sponsor Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveSponsorMasterResponse.isError) {
            let response: any = saveSponsorMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveSponsorMasterResponse.isSuccess, saveSponsorMasterResponse.isError]);

    useEffect(() => {
        if (saveFamilyOfficeMasterResponse.isSuccess) {
            const response: any = saveFamilyOfficeMasterResponse.data;
            alertMessage("Family Office Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveFamilyOfficeMasterResponse.isError) {
            let response: any = saveFamilyOfficeMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveFamilyOfficeMasterResponse.isSuccess, saveFamilyOfficeMasterResponse.isError]);

    //bulk save
    useEffect(() => {
        if (bulkSaveEntityMasterResponse.isSuccess) {
            const response: any = bulkSaveEntityMasterResponse.data;
            alertMessage("Entity Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveEntityMasterResponse.isError) {
            let response: any = bulkSaveEntityMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveEntityMasterResponse.isSuccess, bulkSaveEntityMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveEntityTypeMasterResponse.isSuccess) {
            const response: any = bulkSaveEntityTypeMasterResponse.data;
            alertMessage("Entity Type Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveEntityTypeMasterResponse.isError) {
            let response: any = bulkSaveEntityTypeMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveEntityTypeMasterResponse.isSuccess, bulkSaveEntityTypeMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveInvestmentMandateTypeResponse.isSuccess) {
            const response: any = bulkSaveInvestmentMandateTypeResponse.data;
            alertMessage("Investment Mandate Type added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveInvestmentMandateTypeResponse.isError) {
            let response: any = bulkSaveInvestmentMandateTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveInvestmentMandateTypeResponse.isSuccess, bulkSaveInvestmentMandateTypeResponse.isError]);

    useEffect(() => {
        if (bulkSaveSponsorMasterResponse.isSuccess) {
            const response: any = bulkSaveSponsorMasterResponse.data;
            alertMessage("Sponsor Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveSponsorMasterResponse.isError) {
            let response: any = bulkSaveSponsorMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveSponsorMasterResponse.isSuccess, bulkSaveSponsorMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveFamilyOfficeMasterResponse.isSuccess) {
            const response: any = bulkSaveFamilyOfficeMasterResponse.data;
            alertMessage("Family Office Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveFamilyOfficeMasterResponse.isError) {
            let response: any = bulkSaveFamilyOfficeMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveFamilyOfficeMasterResponse.isSuccess, bulkSaveFamilyOfficeMasterResponse.isError]);

    useEffect(() => {
        if (updateEntityMasterResponse.isSuccess) {
            const response: any = updateEntityMasterResponse.data;
            alertMessage("Entity Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateEntityMasterResponse.isError) {
            let response: any = updateEntityMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateEntityMasterResponse.isSuccess, updateEntityMasterResponse.isError]);

    useEffect(() => {
        if (updateEntityTypeMasterResponse.isSuccess) {
            const response: any = updateEntityTypeMasterResponse.data;
            alertMessage("Entity Type Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateEntityTypeMasterResponse.isError) {
            let response: any = updateEntityTypeMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateEntityTypeMasterResponse.isSuccess, updateEntityTypeMasterResponse.isError]);

    useEffect(() => {
        if (updateInvestmentMandateTypeResponse.isSuccess) {
            const response: any = updateInvestmentMandateTypeResponse.data;
            alertMessage("Investment Mandate Type updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateInvestmentMandateTypeResponse.isError) {
            let response: any = updateInvestmentMandateTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateInvestmentMandateTypeResponse.isSuccess, updateInvestmentMandateTypeResponse.isError]);

    useEffect(() => {
        if (updateSponsorMasterResponse.isSuccess) {
            const response: any = updateSponsorMasterResponse.data;
            alertMessage("Sponsor Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateSponsorMasterResponse.isError) {
            let response: any = updateSponsorMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateSponsorMasterResponse.isSuccess, updateSponsorMasterResponse.isError]);

    useEffect(() => {
        if (updateEntityMasterResponse.isSuccess) {
            const response: any = updateEntityMasterResponse.data;
            alertMessage("Family Office Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateEntityMasterResponse.isError) {
            let response: any = updateEntityMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateEntityMasterResponse.isSuccess, updateEntityMasterResponse.isError]);

    useEffect(() => {
        if (updateFamilyOfficeMasterResponse.isSuccess) {
            const response: any = updateFamilyOfficeMasterResponse.data;
            alertMessage("Family Office Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateFamilyOfficeMasterResponse.isError) {
            let response: any = updateFamilyOfficeMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateFamilyOfficeMasterResponse.isSuccess, updateFamilyOfficeMasterResponse.isError]);


    useEffect(() => {
        if (entityMasterByIdResponse.isSuccess) {
            setGetByIdData(entityMasterByIdResponse.data);
        } else if (entityMasterByIdResponse.isError) {
            let response: any = entityMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [entityMasterByIdResponse.isSuccess, entityMasterByIdResponse.isError]);

    useEffect(() => {
        if (entityTypeMasterByIdResponse.isSuccess) {
            setGetByIdData(entityTypeMasterByIdResponse.data);
        } else if (entityTypeMasterByIdResponse.isError) {
            let response: any = entityTypeMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [entityTypeMasterByIdResponse.isSuccess, entityTypeMasterByIdResponse.isError]);

    useEffect(() => {
        if (investmentMandateTypeByIdResponse.isSuccess) {
            setGetByIdData(investmentMandateTypeByIdResponse.data);
        } else if (investmentMandateTypeByIdResponse.isError) {
            let response: any = investmentMandateTypeByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [investmentMandateTypeByIdResponse.isSuccess, investmentMandateTypeByIdResponse.isError]);

    useEffect(() => {
        if (sponsorMasterByIdResponse.isSuccess) {
            setGetByIdData(sponsorMasterByIdResponse.data);
        } else if (sponsorMasterByIdResponse.isError) {
            let response: any = sponsorMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [sponsorMasterByIdResponse.isSuccess, sponsorMasterByIdResponse.isError]);

    useEffect(() => {
        if (familyOfficeMasterByIdResponse.isSuccess) {
            setGetByIdData(familyOfficeMasterByIdResponse.data);
        } else if (familyOfficeMasterByIdResponse.isError) {
            let response: any = familyOfficeMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [familyOfficeMasterByIdResponse.isSuccess, familyOfficeMasterByIdResponse.isError]);


    const handleClose = () => {
        props.setShow(false);
    };

    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.ENTITY_MASTER) {
                const payload = {
                    name: values.name,
                    code: values.code,
                    entityTypeId: parseInt(values.entityTypeId),
                    dob: values.dob,
                    registrationNo: values.registrationNo,
                    countryId: parseInt(values.countryId),
                    focusArea: values.focusArea,
                    parentEntityId: parseInt(values.parentEntityId),
                    stateId: parseInt(values.stateId),
                    postalCode: parseInt(values.postalCode),
                    geoLocation: values.geoLocation,
                    latitude: location?.latitude,
                    longitude: location?.longitude,
                    phoneNumber: parseInt(values.phoneNumber),
                    email: values.email,
                    websiteUrl: values.websiteUrl,
                    status: true
                }

                const formData = new FormData();
                formData.append('entityMasterReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                if (location.latitude !== '' && location.longitude !== '') {
                    saveEntityMaster({
                        token: localUserObj?.token,
                        payload: formData,
                    });
                } else {
                    alertMessage("Please allow location access to proceed", "error")
                }


            } else if (props.reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
                const payload = {
                    name: values.name,
                    code: values.code,
                    description: values.description,
                    category: values.category,
                    status: true
                }

                saveEntityTypeMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
                const payload = {
                    name: values.name,
                    code: values.code,
                    description: values.description,
                    status: true
                }

                saveInvestmentMandateType({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.SPONSOR_MASTER) {
                saveSponsorMaster({
                    token: localUserObj?.token,
                    payload: {
                        status: true,
                        categoryName: values.name,
                        code: values.code,
                        description: values.description,
                        dependentValueChainCategoryCode: values.dependentValueChainCategoryCode
                    },
                });
            } else if (props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
                saveFamilyOfficeMaster({
                    token: localUserObj?.token,
                    payload: {
                        status: true,
                        name: values.name,
                        code: values.code,
                        legacyGoal: values.legacyGoal,
                        totalAssets: parseInt(values.totalAssets),
                        governanceModel: values.governanceModel,
                        portfolioEntities: [values.portfolioEntities],
                        complianceScore: values.complianceScore
                    },
                });
            }

        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.ENTITY_MASTER) {
                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    code: values.code,
                    dob: values.dob,
                    entityTypeId: parseInt(values.entityTypeId),
                    registrationNo: values.registrationNo,
                    countryId: parseInt(values.countryId),
                    focusArea: values.focusArea,
                    parentEntityId: parseInt(values.parentEntityId),
                    stateId: parseInt(values.stateId),
                    postalCode: parseInt(values.postalCode),
                    geoLocation: values.geoLocation,
                    latitude: location?.latitude,
                    longitude: location?.longitude,
                    phoneNumber: parseInt(values.phoneNumber),
                    email: values.email,
                    websiteUrl: values.websiteUrl,
                    status: props.data.status,
                }

                const formData = new FormData();
                formData.append('entityMasterReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                updateEntityMaster({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    code: values.code,
                    description: values.description,
                    category: values.category,
                    status: props.data.status,
                }

                updateEntityTypeMaster({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: payload
                });
            } else if (props.reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    code: values.code,
                    description: values.description,
                    status: props.data.status,
                }

                updateInvestmentMandateType({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: payload
                });
            } else if (props.reportName === REPORT_NAME.SPONSOR_MASTER) {
                updateSponsorMaster({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: {
                        status: props.data.status,
                        id: props?.data?.id,
                        categoryName: values.name,
                        code: values.code,
                        description: values.description,
                        dependentValueChainCategoryCode: values.dependentValueChainCategoryCode
                    },
                });
            } else if (props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
                updateFamilyOfficeMaster({
                    token: localUserObj?.token,
                    id: props.data.id,
                    payload: {
                        status: props.data.status,
                        id: props.data.id,
                        name: values.name,
                        code: values.code,
                        legacyGoal: values.legacyGoal,
                        totalAssets: parseInt(values.totalAssets),
                        governanceModel: values.governanceModel,
                        portfolioEntities: [values.portfolioEntities],
                        complianceScore: values.complianceScore
                    },
                });
            }
        }
    };

    useEffect(() => {
        if (getAllEntityMasterResponse.isSuccess) {
            dispatch(setAllEntityMaster(getAllEntityMasterResponse));
        }
        else if (getAllEntityMasterResponse.isError) {
            let response: any = getAllEntityMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllEntityMasterResponse.isSuccess, getAllEntityMasterResponse.isError]);

    const handleBulkUpload = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };

    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.ENTITY_MASTER) {
                bulkSaveEntityMaster({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.ENTITY_TYPE_MASTER) {
                bulkSaveEntityTypeMaster({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
                bulkSaveInvestmentMandateType({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.SPONSOR_MASTER) {
                bulkSaveSponsorMaster({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER) {
                bulkSaveFamilyOfficeMaster({
                    token: localUserObj?.token,
                    payload: formData
                });
            }
        }
    }

    const handleGetLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (error) => {
                    alertMessage('Unable to retrieve your location', "error");
                    console.error(error);
                }
            );
        } else {
            alertMessage('Geolocation is not supported by your browser', "error");
        }
    };

    // upload file...............................
    const fileHandler = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        setFileName(fileName)
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        // if (extFile == "pdf" || extFile == "zip" || extFile == "docx") {
        setFile(e.target.files[0]);
        // } else {
        //     alertMessage("Only pdf and zip files are allowed!", "error");
        // }
    };

    const handleDueDiligence = async (formValues: any) => {

        let payload = {};

        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            payload = {
                parent_entity_id: parseInt(props.data?.parentEntityId) || null,
                parent_entity_name: "",
                user_id: localUserObj.id,
                asset_type: "",
                asset_name: "",
                entity_name: props.data?.name,
                entity_type: props.data?.entityType ? props.data?.entityType : null,
                source: REPORT_NAME.ENTITY_MASTER,
                actionType: props.actionType,
                entityId: props.data.id,
            };
        } else {
            payload = {
                parent_entity_id: props.data?.parentEntityId || null,
                parent_entity_name: "",
                user_id: localUserObj.id,
                asset_type: "",
                asset_name: "",
                entity_name: formValues.name,
                entity_type: formValues.entityTypeId
                    ? allEntityTypes.find((t: any) => t.id === formValues.entityTypeId)?.name
                    : "",
                source: REPORT_NAME.ENTITY_MASTER,
                actionType: props.actionType
            };
        }
        getDueDiligence({
            token: localUserObj?.token,
            payload: payload,
        })
    };

    useEffect(() => {
        if (!dueDeligenceData) return;

        const llmRes = dueDeligenceData;

        if (setFieldValueRef.current) {
            setFieldValueRef.current("llmRes", llmRes);
        }
    }, [dueDeligenceData]);

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" }
                )}

            >
                <Modal.Header closeButton>

                    <Modal.Title
                        className="fw-bold text-accent"
                        style={{ fontSize: "1rem" }}
                    >
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {saveEntityMasterResponse.isLoading ||
                        saveEntityTypeMasterResponse.isLoading ||
                        saveSponsorMasterResponse.isLoading ||
                        saveFamilyOfficeMasterResponse.isLoading ||
                        saveInvestmentMandateTypeResponse.isLoading ||

                        bulkSaveEntityMasterResponse.isLoading ||
                        bulkSaveEntityTypeMasterResponse.isLoading ||
                        bulkSaveInvestmentMandateTypeResponse.isLoading ||
                        bulkSaveSponsorMasterResponse.isLoading ||
                        bulkSaveFamilyOfficeMasterResponse.isLoading ||

                        updateEntityMasterResponse.isLoading ||
                        updateEntityTypeMasterResponse.isLoading ||
                        updateInvestmentMandateTypeResponse.isLoading ||
                        updateSponsorMasterResponse.isLoading ||
                        updateFamilyOfficeMasterResponse.isLoading ||

                        entityMasterByIdResponse.isLoading ||
                        entityTypeMasterByIdResponse.isLoading ||
                        investmentMandateTypeByIdResponse.isLoading ||
                        sponsorMasterByIdResponse.isLoading ||
                        familyOfficeMasterByIdResponse.isLoading ||

                        getAllEntityMasterResponse.isLoading ||
                        allSponsorMasterResponse.isLoading ||
                        findAllFamilyOfficeMasterResponse.isLoading ||
                        getAllEntityTypesResponse.isLoading
                        ? (
                            <Loading />
                        ) : (
                            ""
                        )
                    }

                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}


                    {activeTab === "manual" && (
                        <Formik
                            validationSchema={validationSchema}
                            validateOnChange={true}
                            validateOnBlur={true}
                            enableReinitialize={true}
                            initialValues={
                                props.reportName === REPORT_NAME.ENTITY_MASTER ? {
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.code
                                            : "",
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.name
                                            : "",
                                    dob:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.dob
                                            : "",
                                    entityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.entityType?.id
                                            : "",
                                    registrationNo:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.registrationNo
                                            : "",
                                    countryId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.countryId
                                            : "",
                                    focusArea:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.focusArea
                                            : "",
                                    parentEntityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.parentEntityId
                                            : "",
                                    stateId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.stateId
                                            : "",
                                    postalCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.postalCode
                                            : "",
                                    geoLocation:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.geoLocation
                                            : "",
                                    phoneNumber:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.phoneNumber
                                            : "",
                                    email:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.email
                                            : "",
                                    websiteUrl:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.websiteUrl
                                            : "",
                                    verificationFileUpload:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.verificationFileUpload
                                            : "",
                                    llmReq:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.llmReq
                                            : "",
                                    llmRes:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.llmRes
                                            : "",
                                } : props.reportName === REPORT_NAME.SPONSOR_MASTER ? {
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.code
                                            : "",
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.name
                                            : "",
                                    sponsorType:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.sponsorType
                                            : "",
                                    csrBudget:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.csrBudget
                                            : "",
                                    sdgPriorities:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.sdgPriorities
                                            : "",
                                    contactEmail:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.contactEmail
                                            : "",
                                } : props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER ? {
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.code
                                            : "",
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.name
                                            : "",
                                    legacyGoal:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.legacyGoal
                                            : "",
                                    governanceModel:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.governanceModel
                                            : "",
                                    totalAssets:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.totalAssets
                                            : "",
                                    portfolioEntities:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.portfolioEntities
                                            : "",
                                    complianceScore:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.complianceScore
                                            : "",
                                } : {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.name
                                            : "",
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.code
                                            : "",
                                    category:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.category
                                            : "",
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.description
                                            : "",
                                }

                            }
                            onSubmit={handleSubmit}
                        >
                            {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => {

                                // Save setFieldValue so useEffect can access it
                                setFieldValueRef.current = setFieldValue;

                                const isDueDiligenceEnabled = () => {
                                    if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
                                        return (
                                            props.data?.name && props.data.name.trim() !== "" &&
                                            props.data?.entityType && props.data.entityType.id !== ""
                                        );
                                    } else {
                                        return (
                                            values.name && values.name.trim() !== "" &&
                                            values.entityTypeId && values.entityTypeId !== ""
                                        );
                                    }
                                };

                                return (
                                    <Form>
                                        <div className="mt-3">
                                            <div>
                                                <div className="d-flex"> <div>Code</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.code}
                                                    name={"code"}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <div>
                                                <div className="d-flex"> <div> {props.reportName} Name</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.name}
                                                    name={"name"}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {props.reportName === REPORT_NAME.ENTITY_MASTER ? (
                                            <>
                                                <div className="mt-3">
                                                    <div>Date of Birth</div>
                                                    <input
                                                        className="form-control form-control-sm w-50"
                                                        type="date"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={
                                                            values.dob
                                                                ? format(parseISO(values.dob), "yyyy-MM-dd")
                                                                : ""
                                                        }
                                                        name="dob"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Entity Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="entityTypeId"
                                                        value={values.entityTypeId}
                                                    >
                                                        <option value="">Select Entity Type</option>
                                                        {allEntityTypes?.map((type: any, index: number) => (
                                                            <option key={index} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div>Registration No.</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.registrationNo}
                                                        name={"registrationNo"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Focus Area</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.focusArea}
                                                        name={"focusArea"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Country</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                            if (e) {
                                                                getState({
                                                                    token: localUserObj.token,
                                                                    countryId: e.target.value,
                                                                });
                                                            }
                                                        }}
                                                        name="countryId"
                                                        value={values.countryId}
                                                    >
                                                        <option>Country</option>
                                                        {allCountries?.map((country: any) => (
                                                            <option key={country.id} value={country.id}>
                                                                {country.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>State</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="stateId"
                                                        value={values.stateId}
                                                    >
                                                        <option>State</option>
                                                        {allStates?.map((state: any) => (
                                                            <option key={state.id} value={state.id}>
                                                                {state.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Postal Code</div>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        value={values.postalCode}
                                                        name="postalCode"
                                                        onChange={handleChange}
                                                        className="form-control form-textbox bg-secondary-light border-secondary-light"
                                                        id="postalCode"
                                                        placeholder="postalCode"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Phone Number</div>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        value={values.phoneNumber}
                                                        name="phoneNumber"
                                                        onChange={handleChange}
                                                        className="form-control form-textbox bg-secondary-light border-secondary-light"
                                                        id="phoneNumber"
                                                        placeholder="Mobile Number"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Email</div>
                                                    </div>
                                                    <input
                                                        type="email"
                                                        value={values.email}
                                                        name="email"
                                                        onChange={handleChange}
                                                        className="form-control form-textbox bg-secondary-light border-secondary-light"
                                                        id="email"
                                                        placeholder="Email"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Website URL</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        onChange={handleChange}
                                                        value={values.websiteUrl}
                                                        name="websiteUrl"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex"> <div>Location</div>
                                                        <div style={{ color: "red" }}>*</div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-primary btn-block mt-3 mx-2 btn-width`}
                                                        onClick={handleGetLocation}
                                                    >
                                                        Allow Location
                                                    </button>
                                                </div>
                                                <div className="mt-3">
                                                    <div>Upload Verification File</div>
                                                    <div className="d-flex">
                                                        <input
                                                            type="file"
                                                            hidden
                                                            id="fileUpload"
                                                            onChange={(e: any) => {
                                                                fileHandler(e);
                                                                setFieldValue("file", e.target.files[0]);
                                                            }}
                                                        />
                                                        <label htmlFor="fileUpload" className="btn btn-primary mx-2  mt-3" style={{ width: "30%" }}>Upload file</label>
                                                        <p className="mt-4">{fileName}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                                {(props.data.llmReq != null && props.data.llmRes != null) && (
                                                    <div>
                                                        {/* LLM Request */}
                                                        <div className="mt-3">
                                                            <label>LLM Request</label>
                                                            <textarea
                                                                className="form-control"
                                                                rows={5}
                                                                value={values.llmReq}
                                                                readOnly
                                                            // onChange={(e) => setFieldValue("llmReq", e.target.value)}
                                                            />
                                                        </div>

                                                        {/* LLM Response */}
                                                        <div className="mt-3">
                                                            <label>LLM Response</label>
                                                            <textarea
                                                                className="form-control"
                                                                rows={8}
                                                                value={values.llmRes}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-block mt-3 mx-2 btn-width"
                                                    onClick={() => handleDueDiligence(props.actionType === ACTION_TYPE.UPDATE_ACTION ?
                                                        props.data : values)}
                                                    disabled={!isDueDiligenceEnabled()}
                                                >
                                                    Due Diligence
                                                </button>
                                            </>
                                        ) : props.reportName === REPORT_NAME.SPONSOR_MASTER ? (
                                            <>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Sponsor Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="entityTypeId"
                                                        value={values.entityTypeId}
                                                    >
                                                        <option value="">Sponsor Type</option>
                                                        <option value="parent">Parent</option>
                                                        <option value="dependent">Dependent</option>
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div>
                                                        <div>CSR Budget</div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.csrBudget}
                                                            name={"csrBudget"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div>
                                                        <div>SDG Priorities</div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.sdgPriorities}
                                                            name={"sdgPriorities"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Contact Email</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="email"
                                                        onChange={handleChange}
                                                        value={values.contactEmail}
                                                        name="contactEmail"
                                                    />
                                                </div>
                                            </>
                                        ) : props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER ? (
                                            <>
                                                <div className="mt-3">
                                                    <div>Legacy Goal</div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.legacyGoal}
                                                        name="legacyGoal"
                                                    />
                                                </div>

                                                <div className="mt-3">
                                                    <div>Governance Model</div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.governanceModel}
                                                        name="governanceModel"
                                                    />
                                                </div>

                                                <div className="mt-3">
                                                    <div>Total Assets</div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="number"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.totalAssets}
                                                        name="totalAssets"
                                                    />
                                                </div>

                                                <div className="mt-3">
                                                    <div>Portfolio Entities</div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.portfolioEntities}
                                                        name="portfolioEntities"
                                                        placeholder="Enter comma-separated values"
                                                    />
                                                </div>

                                                <div className="mt-3">
                                                    <div>Compliance Score</div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="number"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.complianceScore}
                                                        name="complianceScore"
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="mt-3">
                                                    <div className="col-lg-6 mt-2">
                                                        <div className="d-flex">
                                                            <div>Category</div>
                                                        </div>
                                                        <select
                                                            className="form-select form-textbox"
                                                            onChange={handleChange}
                                                            name="category"
                                                            value={values.category}
                                                        >
                                                            <option value="">Category</option>
                                                            {CATEGORY?.map((country: any) => (
                                                                <option key={country.id} value={country.name}>
                                                                    {country.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div> <div className="d-flex"> <div>Description</div>
                                                    </div>
                                                        <input className="form-control form-control-sm w-100"
                                                            type="text"
                                                            aria-label=".form-control-sm example"
                                                            onChange={handleChange}
                                                            value={values.description}
                                                            name={"description"}
                                                            required />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <div className="d-flex flex-row justify-content-end">
                                            <button
                                                type="submit"
                                                className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                            >
                                                {props.actionType === ACTION_TYPE.ADD_ACTION
                                                    ? "Save"
                                                    : "Update"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                                onClick={handleClose}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </Form>
                                )
                            }}
                        </Formik>
                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                href={`/templates/${props.reportName === REPORT_NAME.ENTITY_MASTER ? 'ENTITY_MASTER'
                                    : props.reportName === REPORT_NAME.ENTITY_TYPE_MASTER ? 'ENTITY_TYPE_MASTER'
                                        : props.reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE ? 'INVESTMENT_MANDATE_TYPE'
                                            : props.reportName === REPORT_NAME.SPONSOR_MASTER ? 'SPONSOR_MASTER'
                                                : props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER ? 'FAMILY_OFFICE_MASTER'
                                                    : ''}.xlsx`}

                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );

};

export default MasterData